<template>
  <ion-list class="ml-[-16px]">
    <ion-radio-group v-model="selected" :allow-empty-selection="true">
      <ion-item
        v-for="(option, index) in options"
        :key="option.value"
        :lines="index === options.length - 1 ? 'none' : 'inset'"
      >
        <ion-radio
          :value="option.value"
          mode="ios"
          justify="start"
          label-placement="end"
        >
          {{ option.value }}
        </ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import { IonList, IonRadioGroup, IonRadio, IonItem } from '@ionic/vue';

const props = defineProps<{
  options: any[];
  value?: string | null;
}>();

const emits = defineEmits<{
  (e: 'onInput', payload: string): void
}>();

const selected = ref<string>(props.value || '');

watch(
  selected,
  () => {
    emits('onInput', selected.value);
  }
);

</script>
<style scoped>
ion-radio {
  --border-radius: 9999px;
  --inner-border-radius: 9999px;
}

ion-radio.ios::part(container) {
  width: 24px;
  height: 24px;

  border: 1px solid var(--ion-color-light);
  border-radius: 9999px;
}

.radio-checked.ios::part(container) {
  border-color: var(--ion-color-primary);
  background: var(--ion-color-primary);
  color: white;
}

ion-radio.radio-checked::part(mark) {
  width: 6px;
  height: 10px;
  margin-top: -2px;
  border-width: 0px 2px 2px 0px;
  border-style: solid;
  border-color: #fff;

  transform: rotate(45deg);
}

ion-item {
  --border-color: var(--ion-color-light);
}

ion-item:last-child {
  border: 0;
}
</style>
